import DownloadStatusProvider from './DownloadStatus.provider';

export default DownloadStatusProvider;
